import React from 'react';
import { ShieldExclamationIcon } from '@heroicons/react/24/solid';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 dark:bg-gray-900 text-center px-6">
      <ShieldExclamationIcon className="h-32 w-32 text-red-600 mb-4" />
      <h1 className="text-4xl font-bold text-gray-800 dark:text-white mb-2">404 - Page Not Found</h1>
      <p className="text-gray-600 dark:text-gray-300 mb-6">
        The page you’re looking for doesn’t exist, has been moved or is under construction.
      </p>
      <Link
        to="/"
        className="bg-[#00318e] text-white px-6 py-2 rounded hover:bg-blue-800 transition"
      >
        Return to Home
      </Link>
    </div>
  );
};

export default NotFoundPage;
